/* Thighrise quick view (operator 07-10): "Others also bought" in the Essential cart drawer opens the whole product in a
   sheet on top of the cart (photos, colour, size, description, Add to cart) instead of a new tab. Each upsell card also
   gets a "View details" link so it is clear it can be opened. Adding goes through /cart/add.js: the drawer refreshes
   by itself on that request. */
(function () {
  function T(k, f) { return (window.SB_T && window.SB_T[k]) || f; }   // multilingual 14-10 (snippets/sb-i18n.liquid)
  function V(v) { return window.SBV ? window.SBV(v) : v; }   // colour names stay English in Shopify; shown translated
  function ON(n) { return T('opt_' + String(n).toLowerCase().replace(/\s+/g, '_'), n); }   // option names stay English in Shopify; label them here
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var E = function (n) { return '[data-essential-cart-element="' + n + '"]'; };
  var dlg, product, sel = {};
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function usd(c) { return window.trMoney ? window.trMoney(c) : (c / 100).toFixed(2); } // Sableau: visitor's currency (layout/theme.liquid)
  function img(src, w) { return src ? src.replace(/(\?|$)/, function (m) { return '?width=' + w + (m === '?' ? '&' : ''); }) : ''; }
  function handleOf(card) { var a = card && card.querySelector(E('upsell-image-container')); var m = a && (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/); return m && m[1]; }

  function build() {
    dlg = document.createElement('dialog');
    dlg.className = 'tr-qv';
    dlg.setAttribute('aria-label', T('details', 'Product details'));
    dlg.innerHTML = '<button type="button" class="tr-qv__x" aria-label="' + T('close', 'Close') + '">&times;</button><div class="tr-qv__body"></div>';
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg || e.target.closest('.tr-qv__x')) return dlg.close();
      var o = e.target.closest('[data-qv-opt]');
      if (o && !o.disabled) { sel[o.dataset.qvOpt] = o.dataset.value; render(); return; }
      var add = e.target.closest('.tr-qv__add');
      if (add) addToCart(add);
    });
    document.body.appendChild(dlg);
  }

  function variant() {
    return product.variants.find(function (v) { return product.options.every(function (o, i) { return sel[i] === undefined || v.options[i] === sel[i]; }); });
  }
  function complete() { return product.options.every(function (o, i) { return sel[i] !== undefined; }); }

  function render() {
    var p = product, v = complete() ? variant() : null;
    var ci = p.options.findIndex(function (o) { return /colou?r/i.test(o.name); });
    var cv = ci >= 0 && sel[ci] !== undefined ? p.variants.find(function (x) { return x.options[ci] === sel[ci] && x.featured_image; }) : null;
    var imgs = p.images.slice();
    if (cv) { var f = cv.featured_image.src; imgs = [f].concat(imgs.filter(function (s) { return s.split('?')[0] !== f.split('?')[0]; })); }
    var shown = v || cv || p.variants[0];
    var opts = p.options.map(function (o, i) {
      var btns = o.values.map(function (val) {
        var ok = p.variants.some(function (x) { return x.options[i] === val && x.available && p.options.every(function (_, j) { return j === i || sel[j] === undefined || x.options[j] === sel[j]; }); });
        var sw = '';
        if (i === ci) { var vi = p.variants.find(function (x) { return x.options[i] === val && x.featured_image; }); if (vi) sw = ' style="background-image:url(\'' + img(vi.featured_image.src, 160) + '\')"'; }
        return '<button type="button" class="tr-qv__opt' + (i === ci ? ' tr-qv__opt--sw' : '') + (sel[i] === val ? ' is-on' : '') + '" data-qv-opt="' + i + '" data-value="' + esc(val) + '"' + (ok ? '' : ' disabled') + sw + ' aria-label="' + esc(ON(o.name) + ': ' + V(val)) + '">' + (i === ci ? '' : esc(V(val))) + '</button>';
      }).join('');
      return '<div class="tr-qv__row"><p class="tr-qv__lbl">' + esc(ON(o.name)) + (sel[i] !== undefined ? ': <b>' + esc(V(sel[i])) + '</b>' : '') + '</p><div class="tr-qv__opts">' + btns + '</div></div>';
    }).join('');
    var off = shown.compare_at_price > shown.price ? Math.floor((shown.compare_at_price - shown.price) * 100 / shown.compare_at_price) : 0;
    var need = p.options.filter(function (o, i) { return sel[i] === undefined; }).map(function (o) { return ON(o.name).toLowerCase(); });
    dlg.querySelector('.tr-qv__body').innerHTML =
      '<div class="tr-qv__gal">' + imgs.map(function (s) { return '<img src="' + img(s, 700) + '" alt="" loading="lazy">'; }).join('') + '</div>' +
      (imgs.length > 1 ? '<p class="tr-qv__hint">' + T('swipe', 'Swipe for more photos') + ' (' + imgs.length + ')</p>' : '') +
      '<div class="tr-qv__info"><h2 class="tr-qv__t">' + esc(p.title) + '</h2>' +
      '<p class="tr-qv__price">' + usd(shown.price) + (off ? ' <s>' + usd(shown.compare_at_price) + '</s> <span class="tr-qv__off">-' + off + '%</span>' : '') + '</p>' +
      opts +
      '<button type="button" class="tr-qv__add"' + (v && !v.available ? ' disabled' : '') + '>' + (v ? (v.available ? T('atc', 'Add to cart') : T('sold_out', 'Sold out')) : T('select', 'Select') + ' ' + need.join(' & ')) + '</button>' +
      '<details class="tr-qv__desc"><summary>' + T('details', 'Product details') + '</summary><div>' + clean(p.description) + '</div></details>' +
      '<a class="tr-qv__full" href="' + ROOT + 'products/' + p.handle + '">' + T('full_page', 'View full page') + '</a></div>';
  }

  // Klaviyo "Added to Cart" for quick adds (review 07-10 M5): the PDP tracker in snippets/klaviyo-tracking.liquid only sees the product form.
  function klAdd(i) {
    try {
      var k = window.klaviyo || (window._klOnsite = window._klOnsite || []);
      k.push(['track', 'Added to Cart', { $value: i.final_line_price / 100, ProductName: i.product_title, ProductID: i.product_id, VariantID: i.variant_id,
        Quantity: i.quantity, Price: i.final_price / 100, ImageURL: i.image, URL: location.origin + i.url }]);
    } catch (e) {}
  }
  // Product description is shop HTML; strip active content before innerHTML (review 07-10).
  function clean(html) {
    var t = document.createElement('template'); t.innerHTML = html || '';
    t.content.querySelectorAll('script,style,iframe,object,embed,form,meta,base,link').forEach(function (n) { n.remove(); });
    t.content.querySelectorAll('*').forEach(function (el) {
      Array.prototype.slice.call(el.attributes).forEach(function (a) {
        var v = a.value.replace(/[\s\u0000-\u001f]+/g, '');
        var url = /^(href|src|srcset|action|formaction|xlink:href|poster)$/i.test(a.name);
        var img = el.tagName === 'IMG' && /^src$/i.test(a.name) && /^data:image\/(png|jpe?g|gif|webp);/i.test(v);
        if (/^on/i.test(a.name) || (url && !img && /^(javascript|data|vbscript):/i.test(v))) el.removeAttribute(a.name);
      });
    });
    return t.innerHTML;
  }
  function addToCart(btn) {
    var v = complete() ? variant() : null;
    if (!v) { var miss = dlg.querySelector('.tr-qv__row:not(:has(b))'); if (miss) miss.classList.add('is-need'); return; }
    btn.disabled = true; btn.textContent = T('adding', 'Adding…');
    fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'content-type': 'application/json', accept: 'application/json' }, body: JSON.stringify({ id: v.id, quantity: 1 }) })
      .then(function (r) { if (!r.ok) throw new Error(r.status); dlg.close(); return r.json(); })
      .then(klAdd)
      .catch(function () { btn.disabled = false; btn.textContent = T('try_again', 'Try again'); });
  }

  function open(handle) {
    if (!dlg) build();
    sel = {}; dlg.querySelector('.tr-qv__body').innerHTML = '<p class="tr-qv__load">' + T('loading', 'Loading…') + '</p>';
    dlg.showModal();
    fetch(ROOT + 'products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
      product = p;
      var ci = p.options.findIndex(function (o) { return /colou?r/i.test(o.name); });
      var first = p.variants.find(function (v) { return v.available; }) || p.variants[0];
      if (ci >= 0) sel[ci] = first.options[ci];
      p.options.forEach(function (o, i) { if (o.values.length === 1) sel[i] = o.values[0]; });
      render();
    }).catch(function () { location.href = ROOT + 'products/' + handle; });
  }

  // Open from the photo, the title or the "View details" link of an upsell card (capture: before the app's own link).
  document.addEventListener('click', function (e) {
    var t = e.target.closest(E('upsell-image-container') + ',' + E('upsell-product-title') + ',.tr-qv-link');
    if (!t) return;
    var h = handleOf(t.closest(E('upsell-product')));
    if (!h) return;
    e.preventDefault(); e.stopPropagation();
    open(h);
  }, true);

  // "View details" under each upsell title; the drawer re-renders often, so re-add when missing.
  function links() {
    document.querySelectorAll(E('upsell-product-title')).forEach(function (t) {
      if (t.nextElementSibling && t.nextElementSibling.classList.contains('tr-qv-link')) return;
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'tr-qv-link'; b.textContent = T('view_details', 'View details');
      t.parentNode.insertBefore(b, t.nextSibling);
    });
  }
  var timer = null;
  new MutationObserver(function () { if (!timer) timer = setTimeout(function () { timer = null; links(); }, 200); })
    .observe(document.documentElement, { childList: true, subtree: true });
  window.trQuickView = open;
})();
